import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000, withCredentials: true });

export const imgSrc = (url) =>
    url && !url.startsWith("http") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;

export const WHATSAPP_NUMBER = "393924851819";

export const waLink = (text) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;